module.exports = __webpack_public_path__ + "media/images/hero/glyph-c3-cde05dbbfc38a51297214f54f702ec44.svg";